import React, {useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {getMemberPushAlarmHistories, getMemberPushAlarmSetting, updateNightSendAllowed} from "../../api/alarmApi";
import {MemberAlarmSettingType} from "../../types/alarm.types";
import {updateMarketingConsent} from "../../api/memberApi";
import {ResponseDto} from "../../api/ResponseDto";



const AlarmSettingPage = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [settings, setSettings] = useState<MemberAlarmSettingType>();

    const getPushAlarmSetting = async () => {
        try {
            setLoading(true);
            const response = await getMemberPushAlarmSetting();
            if (response?.data?.data) {
                setSettings(response.data.data);
            }
        } catch (err) {
            console.error('알림 설정 에러:', err);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        getPushAlarmSetting();
    }, []);


    const apiMap: Record<keyof MemberAlarmSettingType, (value: boolean) => Promise<any>> = {
        marketingConsent: (v) => updateMarketingConsent(v),
        nightSendAllowed: (v) => updateNightSendAllowed(v),
    };

    const handleToggle = async (key: keyof MemberAlarmSettingType) => {
        if (!settings) return;
        const prevSettings = { ...settings };
        const newSettings = { ...settings, [key]: !settings[key] };
        setSettings(newSettings);

        try {
            await apiMap[key](newSettings[key]);
        } catch (err) {
            setSettings(prevSettings);
            console.error('알림 설정 변경 에러:', err);
        }
    };

    return (
        <>
            <header className="sub-header">
                <div className="header-inner">
                    <button type="button" className="backBtn" onClick={() => navigate(-1)}>
                        <span className="blind">뒤로가기</span>
                    </button>
                    <h1 className="subtitle">알림설정</h1>
                </div>
            </header>
            {(!loading && settings) && (() => {

                return (
                    <main className="container no-bottom-nav type_gray">
                        <section className="tit-box-wrap bg-white">
                            <h2 className="headline middle">서비스 알림</h2>
                            <p className="subtit bottom-line">충전, 결제, 이벤트 등의 정보를 빠르게 받아 보세요.</p>
                        </section>
                        <section className="bg-white no-gap">
                            <div className="inner-bottom">
                                <div className="toggle-wrap">
                                    <div className="tit">마케팅 알림</div>
                                    <span className="toggle-box">
                                <input
                                    className="tgl tgl-light"
                                    id="marketingConsent"
                                    type="checkbox"
                                    checked={settings.marketingConsent}
                                    onChange={() => handleToggle('marketingConsent')}
                                />
                                <label className="tgl-btn" htmlFor="marketingConsent"></label>
                            </span>
                                </div>
                                <div className="toggle-wrap">
                                    <div className="tit">야간 PUSH 알림</div>
                                    <span className="toggle-box">
                                <input
                                    className="tgl tgl-light"
                                    id="nightSendAllowed"
                                    type="checkbox"
                                    checked={settings.nightSendAllowed}
                                    onChange={() => handleToggle('nightSendAllowed')}
                                />
                                <label className="tgl-btn" htmlFor="nightSendAllowed"></label>
                            </span>
                                </div>
                            </div>
                        </section>
                    </main>
                )
            })()}
        </>
    );
};

export default AlarmSettingPage;